// extracted by mini-css-extract-plugin
module.exports = {"sort":"UU-z","selected":"VU-z","disabled":"WU-z"};